<div class="text-center">
  <div *ngFor="let error of errors">{{ error }}</div>
  <a (click)="close()" class="btn btn-solid text-uppercase btn-bordered border-thin circle font-size-12 lh-1 font-weight-bold ltr-sp-05 mb-2 mt-3">
    <span class="btn-txt" appTranslate="close"></span>
  </a>
</div>
